export default "__VITE_ASSET__BC5c_YJr__"